module.exports = __webpack_public_path__ + "media/images/flags/32/Malawi-8abb996ed19ee8e297aefb1a9d30f5c6.png";